export const SALES_TAX_PRODUCTS_COLUMN_HEADERS_FOR_CSV_TEMPLATE = [
  'Product Name',
  'Product Taxability Code',
  'SKU',
  'Product Description',
  'Source Platform',
  'Source Platform ID',
];

export const SALES_TAX_PRODUCTS_COLUMN_LIST_FOR_COLUMN_MAPPING: {
  name: string;
  required: boolean;
  label: string;
  advanced: boolean;
}[] = [
  {
    name: 'Product Name',
    required: true,
    label: 'Product Name',
    advanced: false,
  },
  {
    name: 'Product Taxability Code',
    required: false,
    label: 'Product Taxability Code',
    advanced: false,
  },
  {
    name: 'SKU',
    required: true,
    label: 'SKU',
    advanced: false,
  },
  {
    name: 'Product Description',
    required: false,
    label: 'Product Description',
    advanced: false,
  },
  {
    name: 'Source Platform',
    required: false,
    label: 'Source Platform',
    advanced: false,
  },
  {
    name: 'Source Platform ID',
    required: false,
    label: 'Source Platform ID',
    advanced: false,
  },
];

const SALES_TAX_PRODUCTS_COLUMN_KEY_TO_NAME_MAPPING_LIST_FOR_DATA_EXPORT =
  [
    {
      name: 'Product Name',
      key: 'name',
    },
    {
      name: 'Product Taxability Code',
      key: 'taxCode',
    },
    {
      name: 'SKU',
      key: 'sku',
    },
    {
      name: 'Product Description',
      key: 'description',
    },
    {
      name: 'Source Platform',
      key: 'sourcePlatform',
    },
  ];

export const SALES_TAX_PRODUCTS_COLUMN_KEY_TO_NAME_MAPPING_FOR_DATA_EXPORT =
  SALES_TAX_PRODUCTS_COLUMN_KEY_TO_NAME_MAPPING_LIST_FOR_DATA_EXPORT.reduce(
    (acc, header) => ({
      ...acc,
      [header.key]: header.name,
    }),
    {} as Record<string, string>
  );
